/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Copy_Toast_SuccessInputs */



/**
* | output |
* | --- |
* | "Copied to clipboard!" |
*
* @param {Copy_Toast_SuccessInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const copy_toast_success = /** @type {((inputs?: Copy_Toast_SuccessInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Copy_Toast_SuccessInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Copie dans le presse-papiers !")
	if (locale === "de") return /** @type {LocalizedString} */ ("In die Zwischenablage kopiert!")
	if (locale === "it") return /** @type {LocalizedString} */ ("Copiato negli appunti!")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Скопировано в буфер обмена!")
	if (locale === "es") return /** @type {LocalizedString} */ ("¡Copiado al portapapeles!")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("已复制到剪贴板！")
	if (locale === "ja") return /** @type {LocalizedString} */ ("クリップボードにコピーされました!")
	if (locale === "hi") return /** @type {LocalizedString} */ ("क्लिपबोर्ड पर कॉपी हो गया!")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Copiado para a área de transferência!")
	return /** @type {LocalizedString} */ ("Copied to clipboard!")
});